// extracted by mini-css-extract-plugin
export default {"group":"RadioBoxList_group__S+4a+","list":"RadioBoxList_list__Kahiu"};